<template>
  <div class="version-compare-container">
    <div
      class="engine-box"
      ref="engineBox">
      <div
        class="version-title-box title1 dialog-label"
        v-if="mainSceLoaded">
        版本号：{{ `V${fromVersion}` }}
      </div>
      <div
        class="version-title-box title2 dialog-label"
        v-if="mainSceLoaded">
        版本号：{{ `V${toVersion}` }}
      </div>
      <EngineDemo
        ref="engineDemo"
        :modelClick="handleModelClick"
        :loadMainScene="loadMainScene"
        :onMainSceLoaded="onMainSceLoaded" />
      <DragPanel
        v-if="changeInfoVisible"
        title="构件变更详情"
        :closePanel="closeChangeInfoPanel"
        class="change-info-panel-box">
        <div class="changed-info-panel">
          <div class="statistics-info">
            <div
              :class="`item-box ${
                activeChangeType === 'A' ? 'item-active1' : 'bg-color1'
              }`"
              @click="switchChangeType('A')">
              <div class="change-type-box">
                <span class="color1">新增</span>
              </div>
              <div class="count-box">{{ this.newElem.length }}个</div>
            </div>
            <div
              :class="`item-box ${
                activeChangeType === 'D' ? 'item-active2' : 'bg-color2'
              }`"
              @click="switchChangeType('D')">
              <div class="change-type-box">
                <span class="color2">删除</span>
              </div>
              <div class="count-box">{{ this.delElem.length }}个</div>
            </div>
            <div
              :class="`item-box ${
                activeChangeType === 'M' ? 'item-active3' : 'bg-color3'
              }`"
              @click="switchChangeType('M')">
              <div class="change-type-box">
                <span class="color3">修改</span>
              </div>
              <div class="count-box">{{ this.updateElem.length }}个</div>
            </div>
          </div>
          <div class="common-input-box">
            <el-input
              class="input-primary"
              placeholder="请输入构件名称"
              v-model="elemName"
              clearable
              @clear="searchElem"
              @keyup.enter.native="searchElem"
              size="small">
              <i
                slot="suffix"
                class="el-input__icon el-icon-search icon"
                @click="searchElem" />
            </el-input>
          </div>
          <div class="common-tree-box">
            <div
              v-for="(file, index) in fileList"
              :key="index"
              class="files-box">
              <div class="file-box">
                <span
                  v-if="!file.expanded"
                  @click="handeNodeExpand(file)">
                  <i class="el-icon-caret-right icon" />
                </span>
                <span
                  v-if="file.expanded"
                  @click="handeNodeCollapse(file)">
                  <i class="el-icon-caret-bottom icon" />
                </span>
                <span v-if="file.loading">
                  <i class="el-icon-loading icon" />
                </span>
                <span
                  class="text-overflow dialog-label"
                  :title="file.fileName">
                  {{ file.fileName }}
                </span>
              </div>
              <ul
                class="elem-box"
                v-if="file.expanded">
                <li
                  v-for="(elem, index) in file.elemList"
                  :key="index"
                  :class="`${
                    selectElemId === elem.elemIntId
                      ? 'active elem-box-list'
                      : 'elem-box-list'
                  }`"
                  @click="handleElemClick(elem)">
                  <div
                    v-if="activeChangeType === 'M'"
                    class="icon-box">
                    <icon-svg
                      v-if="elem.isElemChange && !elem.isParamChange"
                      class="elem-change"
                      icon-class="ic-goujianduibi" />
                    <icon-svg
                      v-if="elem.isParamChange && !elem.isElemChange"
                      class="param-change"
                      icon-class="ic-shuxingduibi-01" />
                    <icon-svg
                      v-if="elem.isElemChange && elem.isParamChange"
                      class="all-change"
                      icon-class="ic-quanjubiangeng-01" />
                  </div>
                  <div
                    class="text-overflow name-box dialog-label"
                    :title="elem.elemName">
                    {{ elem.elemName }}
                  </div>
                  <div
                    class="result-btn-box"
                    v-if="elem.isParamChange"
                    @click="viewParamsContrastResult(elem)">
                    <span
                      v-if="elem.isParamChange && !elem.isElemChange"
                      class="param-change dialog-label">
                      属性对比结果
                    </span>
                    <span
                      v-if="elem.isParamChange && elem.isElemChange"
                      class="all-change dialog-label">
                      属性对比结果
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div
            class="legend-box"
            v-if="isLegendVisible()">
            <div class="item-box">
              <div class="icon-box">
                <icon-svg
                  class="all-change"
                  icon-class="ic-quanjubiangeng-01" />
              </div>
              <div class="text-box dialog-label">构件与属性同时变更</div>
            </div>
            <div class="item-box">
              <div class="icon-box">
                <icon-svg
                  class="elem-change"
                  icon-class="ic-goujianduibi" />
              </div>
              <div class="text-box dialog-label">构件变更</div>
            </div>
            <div class="item-box">
              <div class="icon-box">
                <icon-svg
                  class="param-change"
                  icon-class="ic-shuxingduibi-01" />
              </div>
              <div class="text-box dialog-label">属性变更</div>
            </div>
          </div>
          <div class="option-box">
            <el-checkbox
              class="checkbox-primary"
              v-model="isAlphaOther"
              @change="handleCheckboxChange">
              定位时半透明其他构件
            </el-checkbox>
          </div>
        </div>
      </DragPanel>
      <div
        v-if="!changeInfoVisible && mainSceLoaded"
        class="changed-info-btn"
        @click="openChangeInfoPanel">
        <icon-svg
          class="icon"
          title="变更详情"
          icon-class="ic-ico_change" />
      </div>
      <AttributePanel
        class="attribute-panel"
        v-show="isAttributePanelVisible"
        :title="attrPanelTitle"
        :attributeData="attributeData"
        :closePanel="closeAttributePanel" />
      <ParamsContrastResultDialog
        :visible="isParamsContrastResultDialogVisible"
        :elemInfo="elemInfo"
        :closeDialog="closeParamsContrastResultDialog" />
      <div
        v-if="!isAttributePanelVisible && mainSceLoaded"
        class="attributes-info-btn"
        @click="openAttributesPanel">
        <icon-svg
          class="icon"
          title="属性"
          icon-class="ic-ico_attribute" />
      </div>
    </div>
  </div>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'
import AttributePanel from '@/components/AttributePanel.vue'
import EngineDemo from '@/components/EngineDemo.vue'
import ParamsContrastResultDialog from './components/ParamsContrastResultDialog.vue'

import {
  getDataSetResService,
  getVersionContrastOverview,
  getProjectParam,
  getVersionContrastFileList,
  getVersionContrastElemList
} from '@/service/interface'

export default {
  data() {
    return {
      mainSceLoaded: false,
      fromVersion: '',
      toVersion: '',

      isAttributePanelVisible: false,
      attrPanelTitle: '属性',
      attributeData: [],

      changeInfoVisible: false,
      activeChangeType: '',
      newElem: [],
      delElem: [],
      updateElem: [],

      elemName: '',
      fileList: [],
      selectElemId: '',
      isAlphaOther: false, // 是否半透明其他构件

      elemInfo: {},
      isParamsContrastResultDialogVisible: false
    }
  },
  components: {
    EngineDemo,
    DragPanel,
    AttributePanel,
    ParamsContrastResultDialog
  },
  beforeRouteLeave(to, from, next) {
    window.BlackHole3D.setViewMode(
      window.BlackHole3D.REVpTypeEm.BIM,
      window.BlackHole3D.REVpTypeEm.None,
      window.BlackHole3D.REVpRankEm.Single
    )

    window.BlackHole3D.Graphics.setSysUIPanelVisible(true)
    window.BlackHole3D.Graphics.setGeoCoordVisible(true)
    window.BlackHole3D.Graphics.setViewCubeVisible(true)

    this.copyCanvas()
    next()
  },
  methods: {
    loadMainScene() {
      this.queryOverview().then(() => {
        this.getDatasetResource().then(() => {
          let assginVer = this.$route.query.fromVersion
          let assginVer2 = this.$route.query.toVersion
          this.fromVersion = assginVer
          this.toVersion = assginVer2
          this.modelInfo.forEach(item => {
            item['assginVer'] = Number(assginVer) - 1
            item['assginVer2'] = Number(assginVer2) - 1
          })

          this.$refs.engineDemo.loadBimVersionCompare(this.modelInfo)
        })
      })
    },
    onMainSceLoaded() {
      this.mainSceLoaded = true
      this.changeInfoVisible = true
      this.isAttributePanelVisible = true
      this.hiddenEngineUI()

      // 加载成功后高亮所有变更类型的构件
      this.setChanedElemColor('A')
      this.setChanedElemColor('D')
      this.setChanedElemColor('M')
    },
    openChangeInfoPanel() {
      this.changeInfoVisible = true
      this.$nextTick(() => {
        this.$refs.engineDemo.onResize()
      })
    },
    closeChangeInfoPanel() {
      this.changeInfoVisible = false
      this.$nextTick(() => {
        this.$refs.engineDemo.onResize()
      })
    },
    switchChangeType(activeChangeType) {
      this.resetElemAttr()

      this.activeChangeType = activeChangeType
      this.selectElemId = ''
      window.BlackHole3D.BIM.delAllSelElems()
      // 将所有构件设为白色半透明
      if (this.isAlphaOther) {
        this.setAllElemAlpha()
      }

      this.setChanedElemColor(activeChangeType)
      this.fileList = this.fileList.map(item => {
        item.expanded = false
        item.elemList = [{ name: '' }]
        return item
      })
      this.queryFileList(activeChangeType)
    },
    handleCheckboxChange(value) {
      if (!this.activeChangeType) return
      if (value) {
        // 将所有构件设为白色半透明
        this.setAllElemAlpha()
      } else {
        this.resetElemAttr()
      }
      this.setChanedElemColor(this.activeChangeType)
    },
    searchElem() {
      let expandedFiles = this.fileList.filter(el => el.expanded)

      this.queryFileList(this.activeChangeType).then(() => {
        let promiseArray = []
        expandedFiles.forEach(file => {
          let find = this.fileList.find(el => el.hostFileId === file.hostFileId)
          find.expanded = true
          let promise = this.queryElemList(find)
          promiseArray.push(promise)
        })
        Promise.all(promiseArray).then(response => {
          if (response.length !== promiseArray.length) {
            let errResponse = response.filter(el => !el.isSuccess)
            if (errResponse.length) {
              this.$message.error(errResponse[0].errMsg)
            }
          }
        })
      })
    },
    handeNodeExpand(file) {
      if (file.elemList && file.elemList[0].elemIntId) {
        file.expanded = true
        return
      }
      this.queryElemList(file)
    },
    handeNodeCollapse(file) {
      file.expanded = false
    },
    handleElemClick(elem) {
      let dataSetId = this.$route.query.dataSetId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find.resId

      const BlackHole3D = window.BlackHole3D

      let newColor = new BlackHole3D.REColor(42, 196, 150, 255)
      let delColor = new BlackHole3D.REColor(243, 100, 100, 255)
      let updateColor = new BlackHole3D.REColor(248, 173, 22, 255)
      let blendAttr = BlackHole3D.BIM.getSelElemsBlendAttr()
      blendAttr.clrWeight = 255
      // blendAttr.alphaWeight = 200;
      if (this.activeChangeType === 'A') {
        blendAttr.elemClr = newColor
      }
      if (this.activeChangeType === 'D') {
        blendAttr.elemClr = delColor
      }
      if (this.activeChangeType === 'M') {
        blendAttr.elemClr = updateColor
      }
      BlackHole3D.BIM.setSelElemsBlendAttr(blendAttr)

      this.resetElemAttr()

      if (this.isAlphaOther) {
        this.setAllElemAlpha()
      }
      this.$refs.engineDemo.highLightCompareEmem(resId, [elem.elemIntId])

      this.selectElemId = elem.elemIntId
    },
    handleModelClick(probeInfo) {
      let elemIds = window.BlackHole3D.BIM.getSelElemIDs()
      if (!elemIds.length) {
        let dataSetId = this.$route.query.dataSetId
        let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
        let resId = find.resId
        window.BlackHole3D.BIM.resetElemAttr(resId, [])
        this.activeChangeType = ''
        this.elemName = ''
        this.fileList = []
        this.attrPanelTitle = '属性'
        this.attributeData = []
        return
      }

      let currVersion = this.getCurrClickVersion(probeInfo)
      this.attrPanelTitle = `属性(V${currVersion})`

      let dataSetId = this.$route.query.dataSetId
      let params = {
        dataSetId: dataSetId,
        elementIntId: probeInfo.elemId,
        version: currVersion,
        isQueryExtend: false
      }
      getProjectParam(params).then(response => {
        if (response.isSuccess) {
          let data = response.data
          let attributeData = data.elementParamGroups
          this.attributeData = attributeData
        } else {
          this.isAttributePanelVisible = false
          this.attributeData = []
          this.$message.error(response.errMsg)
        }
      })
    },
    /**
     * 获取当前点击的版本(由于引擎暂不支持返回当前点击的版本号，因此通过前端代码计算以获取当前点击的版本号)
     */
    getCurrClickVersion(probeInfo) {
      let currVersion = ''

      let domRef = this.$refs.engineDemo.$el
      let canvasWidth = domRef.clientWidth
      let elemScrPos = probeInfo.elemScrPos
      let cursorX = elemScrPos[0]
      let leftWidth = canvasWidth / 2

      if (cursorX < leftWidth) {
        currVersion = this.fromVersion
      } else {
        currVersion = this.toVersion
      }

      return currVersion
    },
    openAttributesPanel() {
      this.isAttributePanelVisible = true
    },
    closeAttributePanel() {
      this.isAttributePanelVisible = false
      this.attributeData = []
    },
    hiddenEngineUI() {
      window.BlackHole3D.Graphics.setGeoCoordVisible(false)
      window.BlackHole3D.Graphics.setViewCubeVisible(false)
      window.BlackHole3D.Graphics.setSysUIPanelVisible(false)
    },
    setChanedElemColor(activeChangeType) {
      let dataSetId = this.$route.query.dataSetId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find.resId
      let newColor = new window.BlackHole3D.REColor(42, 196, 150, 255)
      let delColor = new window.BlackHole3D.REColor(243, 100, 100, 255)
      let updateColor = new window.BlackHole3D.REColor(248, 173, 22, 255)

      if (this.newElem.length && activeChangeType === 'A') {
        let elemAttr = new window.BlackHole3D.REElemAttr()
        elemAttr.dataSetId = resId
        elemAttr.elemIdList = this.newElem
        elemAttr.elemClr = newColor
        window.BlackHole3D.BIM.setElemAttr(elemAttr)
      }
      if (this.delElem.length && activeChangeType === 'D') {
        let elemAttr = new window.BlackHole3D.REElemAttr()
        elemAttr.dataSetId = resId
        elemAttr.elemIdList = this.delElem
        elemAttr.elemClr = delColor
        window.BlackHole3D.BIM.setElemAttr(elemAttr)
      }
      if (this.updateElem.length && activeChangeType === 'M') {
        let elemAttr = new window.BlackHole3D.REElemAttr()
        elemAttr.dataSetId = resId
        elemAttr.elemIdList = this.updateElem
        elemAttr.elemClr = updateColor
        window.BlackHole3D.BIM.setElemAttr(elemAttr)
      }
    },
    queryOverview() {
      return new Promise(resolve => {
        let dataSetId = this.$route.query.dataSetId
        let fromVersion = Number(this.$route.query.fromVersion)
        let toVersion = Number(this.$route.query.toVersion)
        let params = {
          dataSetId,
          fromVersion,
          toVersion
        }
        getVersionContrastOverview(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let newElemInfo = data.find(el => el.dataType === 'A')
            let delElemInfo = data.find(el => el.dataType === 'D')
            let updateInfo = data.find(el => el.dataType === 'M')

            let newElem = newElemInfo
              ? newElemInfo.items.map(el => el.elemId)
              : []
            let delElem = delElemInfo
              ? delElemInfo.items.map(el => el.elemId)
              : []
            let updateElem = updateInfo
              ? updateInfo.items.map(el => el.elemId)
              : []

            this.newElem = newElem
            this.delElem = delElem
            this.updateElem = updateElem
          } else {
            this.$message.error(response.errMsg)
          }
          resolve()
        })
      })
    },
    queryFileList(dataType) {
      return new Promise(resolve => {
        let dataSetId = this.$route.query.dataSetId
        let fromVersion = Number(this.$route.query.fromVersion)
        let toVersion = Number(this.$route.query.toVersion)
        let params = {
          dataSetId,
          fromVersion,
          toVersion,
          dataType: dataType,
          elemName: this.elemName
        }
        getVersionContrastFileList(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let fileList = data.map(item => {
              let obj = {
                dataSetId,
                customType: 'file',
                fromVersion,
                toVersion,
                dataType,
                fileName: item.fileName,
                hostFileId: item.hostFileId,
                elemList: [{ name: '' }],
                expanded: false,
                loading: false
              }
              return obj
            })
            this.fileList = fileList

            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    queryElemList(file) {
      return new Promise(resolve => {
        file.loading = true
        let params = {
          dataSetId: file.dataSetId,
          fromVersion: file.fromVersion,
          toVersion: file.toVersion,
          dataType: file.dataType,
          hostFileId: file.hostFileId,
          elemName: this.elemName
        }
        getVersionContrastElemList(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let elemList = data.map(item => {
              let obj = {
                dataSetId: file.dataSetId,
                customType: 'elem',
                fromVersion: file.fromVersion,
                toVersion: file.toVersion,
                dataType: file.dataType,
                elemName: item.elemName,
                elemIntId: item.elemIntId,
                isElemChange: item.isElemChange,
                isParamChange: item.isParamChange
              }
              return obj
            })

            file.elemList = elemList
            file.loading = false
            file.expanded = true

            resolve()
          }
        })
      })
    },
    setAllElemAlpha() {
      // 将所有构件设为白色半透明
      let dataSetId = this.$route.query.dataSetId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find.resId
      let elemAttr = new window.BlackHole3D.REElemAttr()
      let elemClr = new window.BlackHole3D.REColor(255, 255, 255, 180)
      elemAttr.dataSetId = resId
      elemAttr.elemIdList = []
      elemAttr.elemClr = elemClr
      window.BlackHole3D.BIM.setElemAttr(elemAttr)
    },
    resetElemAttr() {
      let dataSetId = this.$route.query.dataSetId
      let find = this.modelInfo.find(el => el.dataSetId === dataSetId)
      let resId = find.resId
      window.BlackHole3D.BIM.resetElemAttr(resId, [])
    },
    viewParamsContrastResult(elemInfo) {
      this.elemInfo = elemInfo
      this.openParamsContrastResultDialog()
    },
    openParamsContrastResultDialog() {
      this.isParamsContrastResultDialogVisible = true
    },
    closeParamsContrastResultDialog() {
      this.elemInfo = {}
      this.isParamsContrastResultDialogVisible = false
    },
    isLegendVisible() {
      let visible = false
      let isExistExpandFile = this.fileList.some(el => el.expanded)
      if (this.activeChangeType === 'M' && isExistExpandFile) {
        visible = true
      }
      return visible
    },
    getDatasetResource() {
      let dataSetId = this.$route.query.dataSetId
      return new Promise(resolve => {
        getDataSetResService({
          dataSetIds: [dataSetId]
        }).then(response => {
          if (response.isSuccess) {
            let dataSets = response.data
            this.modelInfo = dataSets
            resolve(dataSets)
          }
        })
      })
    },
    copyCanvas() {
      const canvasBox = document.getElementById('engineCanvas')
      if (canvasBox) {
        const canvasContainer = document.getElementById('canvas-container')
        canvasContainer.append(canvasBox)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.version-compare-container {
  width: 100%;
  margin-top: -16px;
  max-width: 100% !important;

  .engine-box {
    position: relative;
    height: 100%;

    .version-title-box {
      position: absolute;
      bottom: 20px;
      padding: 6px 20px;
      font-size: 12px;
      background: var(--base-bg-dark-color7);
      border-radius: 4px;
      z-index: 2;
      color: var(--aside-bg-color);
    }

    .title1 {
      left: calc(50% - 115px);
    }

    .title2 {
      left: calc(100% - 115px);
    }
  }

  .common-drag-panel {
    width: 300px;

    .common-input-box {
      margin: 0px 15px;

      // /deep/ .el-input {
      //   .el-input__inner {
      //     background-color: transparent;

      //     &:hover {
      //       border-color: var(--primary-color);
      //     }

      //     &:focus {
      //       border-color: var(--primary-color);
      //     }
      //   }
      // }

      .icon {
        cursor: pointer;
      }
    }

    /deep/ .content {
      height: calc(100% - 40px);

      .changed-info-panel {
        display: flex;
        flex-direction: column;
        height: 100%;

        .statistics-info {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          padding: 10px 15px;
          gap: 20px;

          .item-box {
            padding: 5px;
            line-height: 25px;
            font-size: 14px;
            background: var(--bim-ver-eng-tab-bgColor);
            border-radius: 4px;
            cursor: pointer;

            .change-type-box {
              display: flex;
              justify-content: center;
              margin: auto;
            }

            .count-box {
              font-size: 12px;
              line-height: 15px;
              color: var(--bim-ver-eng-tab-text-color);
            }

            &:hover {
              color: var(--aside-bg-color);
            }
          }

          .item-active1 {
            background: #2ac496;

            .color1 {
              color: var(--aside-bg-color);
            }

            .count-box {
              color: var(--aside-bg-color);
            }
          }

          .item-active2 {
            background: #f36464;

            .color2 {
              color: var(--aside-bg-color);
            }

            .count-box {
              color: var(--aside-bg-color);
            }
          }

          .item-active3 {
            background: #f8ad16;

            .color3 {
              color: var(--aside-bg-color);
            }

            .count-box {
              color: var(--aside-bg-color);
            }
          }

          .bg-color1 {
            &:hover {
              background: var(--base-bg-light-color8);

              .circle-bg1 {
                background: var(--aside-bg-color);
              }

              .color1 {
                color: var(--aside-bg-color);
              }

              .count-box {
                color: var(--aside-bg-color);
              }
            }

            .circle-bg1 {
              background: var(--base-bg-light-color8);
            }

            .color1 {
              color: var(--base-bg-light-color8);
            }
          }

          .bg-color2 {
            &:hover {
              background: var(--base-bg-light-color9);

              .circle-bg2 {
                background: var(--aside-bg-color);
              }

              .color2 {
                color: var(--aside-bg-color);
              }

              .count-box {
                color: var(--aside-bg-color);
              }
            }

            .circle-bg2 {
              background: var(--base-bg-light-color9);
            }

            .color2 {
              color: var(--base-bg-light-color9);
            }
          }

          .bg-color3 {
            &:hover {
              background: var(--base-bg-light-color10);

              .circle-bg3 {
                background: var(--aside-bg-color);
              }

              .color3 {
                color: var(--aside-bg-color);
              }

              .count-box {
                color: var(--aside-bg-color);
              }
            }

            .circle-bg3 {
              background: var(--base-bg-light-color10);
            }

            .color3 {
              color: var(--base-bg-light-color10);
            }
          }
        }

        .common-tree-box {
          flex-grow: 1;
          margin-top: 10px;
          text-align: left;
          max-height: calc(100% - 140px);
          overflow-y: auto;

          .files-box {
            display: flex;
            flex-direction: column;

            .file-box {
              display: flex;
              align-items: center;
              margin: 5px 15px;
              margin-bottom: 0;

              .icon {
                margin-right: 5px;
                cursor: pointer;
              }

              .el-icon-caret-right {
                color: var(--bim-rvt-uv-icon-color);
              }
            }

            .elem-box {
              flex-grow: 1;
              overflow-y: auto;

              &::-webkit-scrollbar-thumb {
                background-color: rgba(255, 255, 255, 0.3);
              }

              &-list {
                display: flex;
                align-items: center;
                &:not(:last-child) {
                  margin-bottom: 2px;
                }
                &:hover {
                  background-color: var(--base-bg-dark-color33);
                  border-radius: 4px;
                }
              }

              li {
                display: flex;
                margin: 0px 35px;
                padding: 2px 15px;
                border-radius: 5px;
                cursor: pointer;

                &:hover {
                  // background: rgba(255, 255, 255, 0.1);

                  .result-btn-box {
                    display: block;
                  }
                }

                .icon-box {
                  margin-top: 1px;
                  margin-right: 5px;

                  .elem-change {
                    color: #a0ceff;
                  }

                  .param-change {
                    color: #ffa0a0;
                  }

                  .all-change {
                    color: #077ffe;
                  }
                }

                .name-box {
                  flex-grow: 1;
                }

                .result-btn-box {
                  display: none;
                  flex-shrink: 0;
                  height: 100%;
                  line-height: 18px;
                  // padding-bottom: 1px;

                  .param-change {
                    color: #ffa0a0;
                    border-bottom: 1px solid #ffa0a0;
                  }

                  .all-change {
                    color: #077ffe;
                    border-bottom: 1px solid #077ffe;
                  }

                  span {
                    display: flex;
                    align-items: center;
                    margin-bottom: 1px;
                    font-size: 13px;
                  }
                }
              }

              .active {
                background-color: var(--base-bg-light-color24);
              }
            }
          }
        }

        .legend-box {
          display: flex;
          margin: 25px 15px 10px 15px;

          .item-box {
            display: flex;
            align-items: center;
            margin-right: 15px;

            .icon-box {
              margin-right: 5px;

              .elem-change {
                color: #a0ceff;
              }

              .param-change {
                color: #ffa0a0;
              }

              .all-change {
                color: #077ffe;
              }
            }

            .text-box {
              font-size: 14px;
              // color: rgba(255, 255, 255, 0.6);
            }
          }
        }

        .option-box {
          padding: 15px;
          border-top: 1px solid var(--dialog-footer-border-color);
          text-align: left;
          background: var(--dialog-content-bgColor);
          border-bottom-left-radius: 8px;
          border-bottom-right-radius: 8px;

          .el-checkbox {
            color: var(--default-color);
          }
        }
      }
    }
  }

  .change-info-panel-box {
    top: 10px;
    left: 10px;
    width: 400px;
    min-width: 400px;
    height: calc(100% - 80px);
    min-height: 220px;
  }

  .changed-info-btn {
    position: absolute;
    top: 10px;
    left: 10px;
    border: 1px solid var(--base-border-light-color4);
    background: var(--base-bg-denary-color);
    border-radius: 4px;
    padding: 5px 10px;
    color: var(--primary-color);
    cursor: pointer;

    .icon {
      font-size: 20px;
    }
  }

  .attribute-panel {
    top: 10px;
    right: 10px;
    width: 300px;
    height: calc(100% - 80px);
    // background-color: #202020;
    z-index: 2;
  }

  .attributes-info-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    border: 1px solid var(--base-border-light-color4);
    background: var(--base-bg-denary-color);
    border-radius: 4px;
    padding: 5px 10px;
    color: var(--primary-color);
    cursor: pointer;

    .icon {
      font-size: 20px;
    }
  }
}
</style>
